import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    box: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: 171,
      height: 64,
      borderRadius: '0 0 0 8px',
      boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgb(255, 204, 0)',
      lineHeight: 1,
    },
    action: {
      fontSize: 14,
      fontWeight: 500,
      color: 'rgb(0, 0, 0)',
      whiteSpace: 'pre-line',
    },
    icon: {
      marginRight: 16,
    },
    description: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      padding: 16,
      cursor: 'pointer',
    },

    appBar: {
      position: 'relative',
    },
    paper: { backgroundColor: '#ffcc00' },
    modalTitle: {
      marginBottom: 24,
      textAlign: 'center',
    },
    modalIcon: {
      marginBottom: 16,
    },
    subTitle: {
      fontFamily: 'Roboto',
      fontSize: 16,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: 'rgb(0, 0, 0)',
      textAlign: 'center',
      whiteSpace: 'pre-line',
    },
  }
})
